/**
 * 하위 항목에 선택된 카테고리가 있는지 재귀적으로 확인
 */ export const hasSelectedChild = (items, selectedId)=>{
    if (!items || !selectedId) return false;
    return items.some((child)=>child.categoryId === selectedId || child.items && hasSelectedChild(child.items, selectedId));
};
/**
 * 선택된 카테고리의 부모 ID들을 찾기
 */ export const getParentIds = function(categoryId, items) {
    let parents = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    for (const item of items){
        var _item_items;
        if (item.categoryId === categoryId) return parents;
        if ((_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.length) {
            const found = getParentIds(categoryId, item.items, [
                ...parents,
                item.categoryId
            ]);
            if (found.length || item.items.some((child)=>child.categoryId === categoryId)) {
                return found.length ? found : [
                    ...parents,
                    item.categoryId
                ];
            }
        }
    }
    return [];
};
/**
 * 카테고리 ID로 항목 찾기
 */ export const findCategoryItem = (categoryId, items)=>{
    for (const item of items){
        var _item_items;
        if (item.categoryId === categoryId) return item;
        if ((_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.length) {
            const found = findCategoryItem(categoryId, item.items);
            if (found) return found;
        }
    }
    return null;
};
/**
 * 선택된 카테고리의 depth를 계산 (1-based)
 * - depth 1: 최상위 카테고리
 * - depth 2: 최상위의 바로 하위
 * - depth N: N번째 깊이
 * - 선택되지 않은 경우 0 반환
 */ export const getCategoryDepth = function(categoryId, items) {
    let currentDepth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    if (!categoryId) return 0;
    for (const item of items){
        var _item_items;
        if (item.categoryId === categoryId) return currentDepth;
        if ((_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.length) {
            const found = getCategoryDepth(categoryId, item.items, currentDepth + 1);
            if (found > 0) return found;
        }
    }
    return 0;
};
/**
 * 선택된 카테고리가 마지막 depth인지 확인 (하위 항목이 없는 경우)
 */ export const isLastDepthCategory = (categoryId, items)=>{
    if (!categoryId) return false;
    const item = findCategoryItem(categoryId, items);
    return item ? !item.items || item.items.length === 0 : false;
};
/**
 * 선택된 카테고리의 바로 하위 카테고리 목록 가져오기
 * - 2depth에서 사용: 선택된 카테고리의 직속 하위(3depth) 카테고리들만 반환
 */ export const getDirectChildren = (categoryId, items)=>{
    if (!categoryId) return [];
    const item = findCategoryItem(categoryId, items);
    return (item === null || item === void 0 ? void 0 : item.items) || [];
};
/**
 * 선택된 카테고리의 전체 경로를 반환 (breadcrumb용)
 * - 부모 카테고리들 + 현재 카테고리를 순서대로 반환
 */ export const getCategoryPath = (categoryId, items)=>{
    if (!categoryId) return [];
    const parentIds = getParentIds(categoryId, items);
    const currentItem = findCategoryItem(categoryId, items);
    if (!currentItem) return [];
    // 부모 ID들을 CategoryItem으로 변환
    const parentItems = parentIds.map((id)=>findCategoryItem(id, items)).filter((item)=>item !== null);
    return [
        ...parentItems,
        currentItem
    ];
};
